/* ヌリイロ リニューアルデザイン: 共通インタラクション（絞り込み / メソッド進捗 / ヘッダーナビ連動） */

(function () {
  /* ---------- <nuriiro-choose> tabs / filters ---------- */
  if (!customElements.get('nuriiro-choose')) {
    customElements.define(
      'nuriiro-choose',
      class NuriiroChoose extends HTMLElement {
        connectedCallback() {
          this.tabButtons = Array.from(this.querySelectorAll('[data-mode]'));
          this.panels = Array.from(this.querySelectorAll('[data-mode-panel]'));
          this.catChips = Array.from(this.querySelectorAll('[data-cat-chip]'));
          this.artistChips = Array.from(this.querySelectorAll('[data-artist-chip]'));
          this.searchInput = this.querySelector('[data-choose-search]');
          this.priceSelect = this.querySelector('[data-choose-price]');
          this.sortSelect = this.querySelector('[data-choose-sort]');
          this.resultEl = this.querySelector('[data-choose-result]');
          this.grid = this.querySelector('[data-choose-grid]');
          this.cards = Array.from(this.querySelectorAll('[data-pool]'));
          this.moreWrap = this.querySelector('[data-choose-more]');
          this.moreBtn = this.querySelector('[data-choose-show-more]');
          this.emptyEl = this.querySelector('[data-choose-empty]');
          this.pageSize = parseInt(this.dataset.pageSize, 10) || 8;
          this.visibleCount = this.pageSize;

          this.state = {
            mode: this.tabButtons[0] ? this.tabButtons[0].dataset.mode : 'lesson',
            cats: [],
            artist: 'all',
          };

          this.tabButtons.forEach((btn) => btn.addEventListener('click', () => this.setMode(btn.dataset.mode)));
          this.catChips.forEach((chip) => chip.addEventListener('click', () => this.toggleCat(chip.dataset.catChip)));
          this.artistChips.forEach((chip) => chip.addEventListener('click', () => this.setArtist(chip.dataset.artistChip)));
          if (this.searchInput) this.searchInput.addEventListener('input', () => this.onFilterChange());
          if (this.priceSelect) this.priceSelect.addEventListener('change', () => this.onFilterChange());
          if (this.sortSelect) this.sortSelect.addEventListener('change', () => this.onFilterChange());
          if (this.moreBtn) {
            this.moreBtn.addEventListener('click', () => {
              this.visibleCount += this.pageSize;
              this.render();
            });
          }
          if (this.moreWrap && this.dataset.infiniteScroll === 'true' && 'IntersectionObserver' in window) {
            this.moreObserver = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.visibleCount += this.pageSize;
                  this.render();
                }
              });
            });
            this.moreObserver.observe(this.moreWrap);
          }

          this.render();
        }

        onFilterChange() {
          this.visibleCount = this.pageSize;
          this.render();
        }
        setMode(mode) {
          this.state.mode = mode;
          this.visibleCount = this.pageSize;
          this.render();
        }
        toggleCat(cat) {
          if (cat === 'all') {
            this.state.cats = [];
          } else {
            var idx = this.state.cats.indexOf(cat);
            if (idx === -1) {
              this.state.cats.push(cat);
            } else {
              this.state.cats.splice(idx, 1);
            }
          }
          this.visibleCount = this.pageSize;
          this.render();
        }
        setArtist(artist) {
          this.state.artist = artist;
          this.visibleCount = this.pageSize;
          this.render();
        }

        render() {
          var s = this.state;
          this.tabButtons.forEach((btn) => btn.classList.toggle('is-active', btn.dataset.mode === s.mode));
          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.modePanel !== s.mode;
          });
          this.catChips.forEach((chip) => {
            var isAll = chip.dataset.catChip === 'all';
            chip.classList.toggle('is-active', isAll ? s.cats.length === 0 : s.cats.indexOf(chip.dataset.catChip) !== -1);
          });
          this.artistChips.forEach((chip) => chip.classList.toggle('is-active', chip.dataset.artistChip === s.artist));

          var q = (this.searchInput && this.searchInput.value.trim().toLowerCase()) || '';
          var price = (this.priceSelect && this.priceSelect.value) || 'all';
          var sort = (this.sortSelect && this.sortSelect.value) || 'new';
          var visiblePool = s.mode === 'lesson' ? 'lesson' : 'browse';

          var matching = this.cards.filter((card) => {
            if (card.dataset.pool !== visiblePool) return false;
            var cardCats = (card.dataset.cat || '').split(' ').filter(Boolean);
            if (s.mode === 'cat' && s.cats.length && !s.cats.some((c) => cardCats.indexOf(c) !== -1)) return false;
            if (s.mode === 'artist' && s.artist !== 'all' && card.dataset.artist !== s.artist) return false;
            if (price === 'free' && card.dataset.free !== 'true') return false;
            if (price === 'paid' && card.dataset.free === 'true') return false;
            if (q && (card.dataset.search || '').indexOf(q) === -1) return false;
            return true;
          });

          matching.sort((a, b) => {
            if (sort === 'price_asc') return (parseFloat(a.dataset.price) || 0) - (parseFloat(b.dataset.price) || 0);
            if (sort === 'price_desc') return (parseFloat(b.dataset.price) || 0) - (parseFloat(a.dataset.price) || 0);
            return (parseInt(b.dataset.date, 10) || 0) - (parseInt(a.dataset.date, 10) || 0);
          });

          var matchingSet = new Set(matching);
          this.cards.forEach((card) => {
            card.hidden = !matchingSet.has(card);
          });
          if (this.grid) {
            matching.forEach((card, i) => {
              this.grid.appendChild(card);
              card.classList.toggle('is-hidden-more', i >= this.visibleCount);
            });
          }

          if (this.resultEl) {
            var itemsLabel = this.resultEl.dataset.labelTemplate || '[count]';
            this.resultEl.textContent = itemsLabel.replace('[count]', matching.length);
          }
          if (this.moreWrap) {
            this.moreWrap.style.display = matching.length > this.visibleCount ? 'flex' : 'none';
          }
          if (this.emptyEl) this.emptyEl.hidden = matching.length !== 0;
        }
      }
    );
  }

  /* ---------- homepage header nav highlight ---------- */
  function initHomeNavHighlight() {
    var sections = document.querySelectorAll('[data-nuriiro-section]');
    var navLinks = document.querySelectorAll('[data-nuriiro-nav-link]');
    if (!sections.length || !navLinks.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.getAttribute('data-nuriiro-section');
          navLinks.forEach(function (link) {
            link.classList.toggle('is-current-section', link.getAttribute('data-nuriiro-nav-link') === id);
          });
        });
      },
      { rootMargin: '-45% 0px -50% 0px' }
    );
    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  /* ---------- <hero-slider> peek carousel（クローンスライドで無限ループ） ---------- */
  if (!customElements.get('hero-slider')) {
    customElements.define(
      'hero-slider',
      class HeroSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-hero-track]');
          if (!this.track) return;
          this.realSlides = Array.from(this.track.children);
          this.count = this.realSlides.length;
          this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
          this.prevBtn = this.querySelector('[data-hero-prev]');
          this.nextBtn = this.querySelector('[data-hero-next]');

          if (this.count <= 1) {
            return;
          }

          var firstClone = this.realSlides[0].cloneNode(true);
          var lastClone = this.realSlides[this.count - 1].cloneNode(true);
          this.track.insertBefore(lastClone, this.realSlides[0]);
          this.track.appendChild(firstClone);

          this.pos = 1;
          this.track.addEventListener('transitionend', this.onTransitionEnd.bind(this));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.go(this.pos + 1); this.restartAutoplay(); });
          if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.go(this.pos - 1); this.restartAutoplay(); });
          this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i + 1); this.restartAutoplay(); }));

          this.track.addEventListener('touchstart', (e) => {
            this.touchStartX = e.touches[0].clientX;
            this.touchStartY = e.touches[0].clientY;
          }, { passive: true });
          this.track.addEventListener('touchend', (e) => {
            if (this.touchStartX == null) return;
            var dx = e.changedTouches[0].clientX - this.touchStartX;
            var dy = e.changedTouches[0].clientY - this.touchStartY;
            this.touchStartX = null;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
              this.go(this.pos + (dx < 0 ? 1 : -1));
              this.restartAutoplay();
            }
          }, { passive: true });

          this.render(false);
          this.startAutoplay();
        }

        disconnectedCallback() {
          this.stopAutoplay();
          clearTimeout(this.wrapTimer);
        }

        startAutoplay() {
          this.autoplayTimer = setInterval(() => this.go(this.pos + 1), 6000);
        }

        stopAutoplay() {
          if (this.autoplayTimer) clearInterval(this.autoplayTimer);
        }

        restartAutoplay() {
          this.stopAutoplay();
          this.startAutoplay();
        }

        go(pos) {
          this.pos = pos;
          this.render(true);
          // transitionend is not guaranteed to fire in every environment
          // (interrupted transitions, throttled/background tabs, reduced motion),
          // so a timeout fallback ensures the loop-wrap reset always runs.
          clearTimeout(this.wrapTimer);
          this.wrapTimer = setTimeout(this.onTransitionEnd.bind(this), 650);
        }

        onTransitionEnd() {
          clearTimeout(this.wrapTimer);
          if (this.pos <= 0) {
            this.pos = this.count;
            this.render(false);
          } else if (this.pos >= this.count + 1) {
            this.pos = 1;
            this.render(false);
          }
        }

        render(animate) {
          this.track.style.transition = animate ? '' : 'none';
          this.track.style.transform = 'translateX(-' + this.pos * 100 + '%)';
          if (!animate) {
            void this.track.offsetHeight;
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                this.track.style.transition = '';
              });
            });
          }
          var idx = ((this.pos - 1) % this.count + this.count) % this.count;
          this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === idx));
        }
      }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHomeNavHighlight();
  });
})();
